/**
 *  Summary: Set and manage a freebrochure form into the full image viewer
 */
(function freeBrochureHandler(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  const previousFreeBrochureHandler =
    global.NewHomeSource.FullImageViewer.FreeBrochureHandler;
  const eventToAttach = global.NewHomeSource.FullImageViewer.Config.getClickOrTouchEvent();
  const queryFreeBrochureCallToAction = '[data-component="full-image-viewer-free-brochure-cta"]';
  let fieldsConfig = {};

  /**
   * @constructs NewHomeSource.FullImageViewer.FreeBrochureHandler
   */
  function FreeBrochureHandler() { }

  /**
   * @private
   * fillFields: calculate the DOM elements for the FIV.
   * Note: when the user closes the FIV, the template element
   *       is deleted, so, we need calculate the new elements
  */
  function fillFields() {
    fieldsConfig = {
      backButton: global.document.querySelector('[data-close-modal]'),
      panelForm: global.document.querySelector('[data-panel-form]'),
      moreInfoButton: global.document.querySelector('[data-more-information-btn]'),
      elementsActions: global.document.querySelectorAll('[data-more-info]'),
      panelActionContainer: global.document.querySelector('[data-panel-actions]'),
      freeBrochureButton: global.document.querySelector(queryFreeBrochureCallToAction)
    };
  }

  function showThankYouModal(event) {
    const html = event.detail.htmlResponse;
    const isModalReadyToDisplay = event.detail.isModalReadyToDisplay;

    if (!fieldsConfig.panelForm || !html) {
      return;
    }

    fieldsConfig.backButton.click();

    if (isModalReadyToDisplay) {
      window.NewHomeSource.ModalLoader.displayModal();
    } else {
      const fragment = document.createRange().createContextualFragment(html);
      window.NewHomeSource.ModalLoader.createModal(fragment, fieldsConfig.freeBrochureButton);
    }
  }

  /**
   * @private
   * backFromFormEvent: supports the action of closing the form.
  */
  function backFromFormEvent(event) {
    event.preventDefault();

    const leadEvents = global.NewHomeSource.Modules.tagManager.getFromDataLayer('leadEvents') || {};
    const form = fieldsConfig.panelForm.querySelector('[data-form-container]');

    fieldsConfig.panelActionContainer.removeAttribute('hidden');
    fieldsConfig.panelForm.setAttribute('hidden', '');
    fieldsConfig.backButton.dataset.ga4EventButton_name = leadEvents.ButtonNameClicked || '';
    fieldsConfig.moreInfoButton.removeAttribute('hidden');

    if (form) {
      form.remove();
    }

    for (let index = 0; index < fieldsConfig.elementsActions.length; index += 1) {
      fieldsConfig.elementsActions[index].setAttribute('hidden', '');
    }

    fieldsConfig.backButton.removeEventListener(eventToAttach, backFromFormEvent);
    fieldsConfig.backButton.removeAttribute('hidden');
    fieldsConfig = {};
  }

  /**
   * Use the fetch API to get the HTML modal content from the server
   * @param {string} url
   * @returns the HTML as a raw string
   */
  async function fetchFreeBrochureForm(url) {
    const request = await fetch(url, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    const response = await request.text();
    const fragment = document.createRange().createContextualFragment(response);
    return fragment;
  }

  /**
   * @public
   * setUpForm: Sets up the any free brochure form into any container
   * @param {HTMLElement} container DOM container element
   * @param {string} htmlContent Html content from fetch result
   */
  FreeBrochureHandler.Init = async function setUpForm(container, url) {
    if (!container || !url) {
      return;
    }

    fillFields();

    const fragment = await fetchFreeBrochureForm(url);
    const form = fragment.querySelector('[data-form-container]');
    const leadButton = form.querySelector('#nhs_GetBrochure');
    leadButton.dataset.isFullImageViewerLead = true;
    container.appendChild(form);

    fieldsConfig.backButton.addEventListener(eventToAttach, backFromFormEvent);
  };

  /**
   * @public
   * noConflict: Returns control of NewHomeSource.FreeBrochureHandler to the previous script.
   */
  FreeBrochureHandler.noConflict = function noConflict() {
    global.NewHomeSource.FullImageViewer.FreeBrochureHandler = previousFreeBrochureHandler;
    return FreeBrochureHandler;
  };

  global.document.body.addEventListener('onThankYouModalLoaded', showThankYouModal);
  global.NewHomeSource.FullImageViewer.FreeBrochureHandler = FreeBrochureHandler;
}(window));
